module.exports = __webpack_public_path__ + "img/avatar-s-4.61de186b.jpg";